import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import {
    BreadCrumbs,
    PageTitleWithToolTip,
} from '../Common';
import DataGrid from '../Common/DataGrid';
import UserInfo from '../../UserInfo';
import Routes from '../../routes';
import { trakrefFontFamily, postRequestHeaders, fetchFilterValues } from '../../utils';
import { Grid, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useNavigate from '../../hooks/useNavigate';
import { text_commonCellProps, select_commonCellProps } from '../Common/DataGrid/utils';
import { StyledCellLink } from '../Common/DataGrid/CellComponents';
import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF, GridActionsCellItem } from '@mui/x-data-grid-pro';


const ServiceProvidersLinkedLocations = ({}) => {
    const [filterOptions, setFilterOptions] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const navigate = useNavigate({ pageName: 'LinkServiceProviders' });
    const mainText = "Locations linked to Service Providers";

    useEffect(() => {
        const fetchFilterData = async () => {
            const data = await fetchFilterValues(Routes.Location.GetServicerLocationFilterValues());
            setFilterOptions(data);
        };

        fetchFilterData();
    }, []);

    const columns = [
        {
            field: 'locationName',
            headerName: 'Location Name',
            ...select_commonCellProps,
            renderCell: ({ row }) => (
                <StyledCellLink
                    primaryLink
                    path={`Location/${row.loctationId}`}
                    text={row.locationName}
                    from={window.location.pathname}
                />
            )
        },
        {
            field: 'locationCode',
            headerName: 'Location Code',
            ...text_commonCellProps,
        },
        {
            field: 'servicerName',
            headerName: 'Service Provider Name',
            ...select_commonCellProps,
        },
        {
            ...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
            field: 'Quick Actions',
            align: 'right',
            flex: 1,
            renderCell: ({ row }) => {
                const isVisible = row.grantType?.toLowerCase() === "specific locations";
                if (!isVisible) return [];
                return [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Revoke Access to Location">
                                <CloseIcon />
                            </Tooltip>
                        }
                        onClick={() => handleRevokeAccess(row.id)}
                        label="Revoke Access"
                    />
                ];
            }
        }

    ];

    const handleRevokeAccess = async (id) => {
        try {
            const response = await fetch(Routes.Location.RevokeServicerLocation(id), {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
            });
    
            if (response.ok) {
                setRefresh(!refresh);
                toast.success('Location linked to service provider revoked successfully', { duration: 6000 });
            } else {
                toast.error(`Failed to revoke location`, { duration: 6000 });
            }
        } catch (error) {
            console.error('Error', error);
            toast.error('Failed to revoke location', { duration: 6000 });
        }
    };

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: "Account Details", to: "/Account" },
                    { text: "My Service Providers", to: "/MyServiceProviders" },
                    { text: mainText }
                ]}
            />

            <Grid container spacing={2}>
                <Grid item>
                    <IconButton aria-label="close" onClick={() => navigate.goBack()}>
                        <CloseIcon />
                    </IconButton>
                </Grid>
                <Grid item xs={6}>
                    <PageTitleWithToolTip
                        pageTitle={mainText}
                        toolTipText="Manage which service providers can be linked to the client account, and set up their restrictions and privileges"
                    />
                </Grid>
                <Grid item xs={12}>
                      <DataGrid
                        url={Routes.Location.GetServicerLocations()}
                        filterOptions={filterOptions}
                        columns={columns}
                        noResultText="Oops...It is empty here..."
                        noResultText2="No locations are currently linked to service providers"
                        exportButtonURL={Routes.Location.GetServicerLocationsExport?.()}
                        exportButtonAlt="Export Locations linked to Service Providers (.csv)"
                        exportFileName="ServiceProvidersLinkedLocations"
                        exportFileTypes={[{ type: 'csv', name: 'CSV' }]}
                        tableHeader="Locations linked to Service Providers"
                        tableHeaderTooltipText="Manage which service providers can be linked to the client account"
                        refresh={refresh}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default ServiceProvidersLinkedLocations;
